var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgChecklist = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_187_54",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_187_54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.52499 16.175L9.07499 12.625C9.27499 12.425 9.50832 12.3292 9.77499 12.3375C10.0417 12.3458 10.275 12.45 10.475 12.65C10.6583 12.85 10.75 13.0833 10.75 13.35C10.75 13.6167 10.6583 13.85 10.475 14.05L6.24999 18.3C6.04999 18.5 5.81665 18.6 5.54999 18.6C5.28332 18.6 5.04999 18.5 4.84999 18.3L2.69999 16.15C2.51665 15.9667 2.42499 15.7333 2.42499 15.45C2.42499 15.1667 2.51665 14.9333 2.69999 14.75C2.88332 14.5667 3.11665 14.475 3.39999 14.475C3.68332 14.475 3.91665 14.5667 4.09999 14.75L5.52499 16.175ZM5.52499 8.17501L9.07499 4.62501C9.27499 4.42501 9.50832 4.32917 9.77499 4.33751C10.0417 4.34584 10.275 4.45001 10.475 4.65001C10.6583 4.85001 10.75 5.08334 10.75 5.35001C10.75 5.61667 10.6583 5.85001 10.475 6.05001L6.24999 10.3C6.04999 10.5 5.81665 10.6 5.54999 10.6C5.28332 10.6 5.04999 10.5 4.84999 10.3L2.69999 8.15001C2.51665 7.96667 2.42499 7.73334 2.42499 7.45001C2.42499 7.16667 2.51665 6.93334 2.69999 6.75001C2.88332 6.56667 3.11665 6.47501 3.39999 6.47501C3.68332 6.47501 3.91665 6.56667 4.09999 6.75001L5.52499 8.17501ZM14 17C13.7167 17 13.4792 16.9042 13.2875 16.7125C13.0958 16.5208 13 16.2833 13 16C13 15.7167 13.0958 15.4792 13.2875 15.2875C13.4792 15.0958 13.7167 15 14 15H21C21.2833 15 21.5208 15.0958 21.7125 15.2875C21.9042 15.4792 22 15.7167 22 16C22 16.2833 21.9042 16.5208 21.7125 16.7125C21.5208 16.9042 21.2833 17 21 17H14ZM14 9.00001C13.7167 9.00001 13.4792 8.90417 13.2875 8.71251C13.0958 8.52084 13 8.28334 13 8.00001C13 7.71667 13.0958 7.47917 13.2875 7.28751C13.4792 7.09584 13.7167 7.00001 14 7.00001H21C21.2833 7.00001 21.5208 7.09584 21.7125 7.28751C21.9042 7.47917 22 7.71667 22 8.00001C22 8.28334 21.9042 8.52084 21.7125 8.71251C21.5208 8.90417 21.2833 9.00001 21 9.00001H14Z",
    fill: "white"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChecklist);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/checklist.a74214b67d1f17029ff6e715d18bf131.svg";